var $parse;

class UserFormDirective {
	constructor(_$parse) {
		this.require = '^userApi';
		this.restrict = 'A';
		$parse = _$parse;
	}

	link(scope, elem, attrs, userApiController) {
		userApiController.$promises.push($parse(attrs.userForm)(scope));
	}

	static directiveFactory($parse){
		return new UserFormDirective($parse);
	}
}

var factory = UserFormDirective.directiveFactory;
factory.$inject = ['$parse'];

export default factory;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/orgchart/directive.UserForm.es6.js